import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {ICommunityCtaModel} from "../../../models/community/cta/ICommunityCtaModel";
import {ICommunityCtaCreateOutgoing} from "../../../models/community/cta/ICommunityCtaCreateOutgoing";
import {ICommunityCtaUpdateOutgoing} from "../../../models/community/cta/ICommunityCtaUpdateOutgoing";
import {ICommunityCtaGeneratedIncoming} from "../../../models/community/cta/ICommunityCtaGeneratedIncoming";

export class CommunityCtaService {

    public static generatedEvents: ((event: ICommunityCtaGeneratedIncoming) => void)[] = [];

    public static dispose(): void {
        this.generatedEvents = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_CTA_GENERATED, (event: ICommunityCtaGeneratedIncoming) => {
            this.generatedEvents.forEach(value => value(event));
        });
    }

    public static onGenerated(component: INetworkComponent, func: (event: ICommunityCtaGeneratedIncoming) => void) {
        this.generatedEvents.push(func);
        component.onRemove(() => arrayRemove(this.generatedEvents, func));
    }

    public static async list(communityId: string, component?: INetworkComponent): Promise<ICommunityCtaModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/cta/list/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async create(communityId: string, data: ICommunityCtaCreateOutgoing, component?: INetworkComponent): Promise<ICommunityCtaModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/cta/${communityId}`, data, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async generate(communityId: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/cta/${communityId}/generate`, {}, component);
        return request.status == HttpStatus.OK;
    }

    public static async duplicate(ctaId: string, component?: INetworkComponent): Promise<ICommunityCtaModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/cta/${ctaId}/duplicate`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async update(data: ICommunityCtaUpdateOutgoing, component?: INetworkComponent): Promise<ICommunityCtaModel> {
        let request = await Network.putJson(ProductType.COMMUNITY, `/community/cta`, data, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async delete(ctaId: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.delete(ProductType.COMMUNITY, `/community/cta/${ctaId}`, component);
        return request.status == HttpStatus.OK;
    }
}
